import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FieldRenderProps } from 'react-final-form';
import locale from 'date-fns/locale/ru';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

export default ({
  input: { name, onChange, value, ...restInput },
  label,
  meta,
  fullWidth,
  ...rest
}: FieldRenderProps<string>) => (
  <LocalizationProvider locale={locale} dateAdapter={AdapterDateFns}>
    <DatePicker
      label={label}
      onChange={onChange}
      disableFuture
      value={value || null}
      mask="__.__.____"
      renderInput={(props: any) => (
        <TextField
          {...props}
          {...restInput}
          fullWidth={fullWidth}
          name={name}
          error={Boolean(meta?.touched && meta?.error)}
          helperText={meta?.touched ? meta?.error : ''}
        />
      )}
      {...rest}
    />
  </LocalizationProvider>
);
